
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(0(|77|79)|2(05|56|88)|141|370|561|898)|2(7(36|39|41|7)|9(59|63|97)|(14|25|38)0|014|164|396|599|848|869)|5((02|57|68)0|(16|72|93)5|289|366|694|769)|6(154|338|557)|1(8(1|41|98)|074|097|187|265|333|39|456|51|683)|8(9(13|70|91)|7(24|67|74)|6(2|45|49)|22|305|332|470|491|824)|7(4(27|48|65)|3(1|39|58|62|76)|209|770|78|873|966)|3(6(53|61|72|94|98)|(0|31|59)1|08|457|970)|9(6(04|42|65)|7(5|57|63)|3(11|34|94)|0|013|272|431|500|517|879))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
